module.exports = __webpack_public_path__ + "static/wff-sec5-04-3655e7c3ad7133cc8ed823da25fed03e.jpg";